/**
 * 上传队列
 *
 * @export
 * @class SpriteService
 */
import _ from 'lodash';
import Api from '../../services/api';
import CONSTANT from '../../constant';
import Emitter from '../emitter';
import { getFileName, isOnline } from '../../util';
import mElectronApi from '../../util/electron';
import ProjectLocal from '../../services/project/project.local';
class Uploader {

    constructor() {
        this.store = null;
        this.MQueue = window.MbApi.MQueue;
        this.isUploading = false;   // 正在上传标志
        console.log('MQueue TASK 注册.');
        this.MQueue.Task((length) => {
            Emitter.emit('MQueue.Upload.run', length);
        });
    }

    static getInstance() {
        if (!Uploader.instance) {
            Uploader.instance = new Uploader();
        }
        return Uploader.instance;
    }

    Constant() {
        return {
            PROJECT: 'PROJECT',
            COVER_IMAGE: 'COVER_IMAGE'
        };
    }

    GetList() {
        return this.MQueue.GetList();
    }

    Push(args) {
        return this.MQueue.Push(args);
    }

    // 设置store
    SetStore(store) {
        this.store = store;
        return this;
    }

    pop() {
        return this.MQueue.Pop();
    }

    run() {
        // 没有网络 && 上传中
        if (!isOnline() || this.isUploading) {
            return console.log('没有网络或有任务正在上传...');
        }
        const thisItem = this.pop();
        if (!_.isObject(thisItem) || !_.has(thisItem, 'type')) {
            return console.log('消息队列中的数据结构不正确。missing type');
        }
        if (!_.has(thisItem, 'data')) {
            return console.log('消息队列中的数据结构不正确。missing data');
        }

        const type = thisItem.type;
        const data = thisItem.data;
        const c = this.Constant();

        console.log('MQueue 触发.');

        switch (type) {
            case c.PROJECT:
                return this.runProject(data);
            // case c.COVER_IMAGE:
            //     return this.runCoverImage(data);
            default:
                console.log('MQueue uploader type 不匹配');
                return;
        }
    }

    // 文件buffer转File对象
    async getBufferToFile(filePath) {
        const fileObj = await mElectronApi.read(filePath);
        return new File(Array(fileObj.data), getFileName(filePath));
    }

    getStoreUid() {
        const { account } = this.store.getState();
        return account.data.uid || 'null';
    }

    findProjectByStore(id) {
        const { project } = this.store.getState();
        const { projects } = project;
        let projectItem = {};
        projects.forEach((v) => {
            if (id === v.id) {
                projectItem = v;
            }
            return;
        });
        return projectItem;
    }

    /**
     * 上传项目
     * @param data
     * {
     * filePath: xx,  //文件路径
     * id: xx   //项目id
     * }
     * @returns {Promise<void>}
     */
    async runProject(data) {
        console.log('run project', data);

        if (!_.isObject(data) || !_.has(data, 'filePath')) {
            return console.log('上传项目数据结构不正确。missing filePath');
        }
        if (!_.has(data, 'utoken')) {
            return console.log('上传项目数据结构不正确。missing utoken');
        }
        if (!_.has(data, 'uid')) {
            return console.log('上传项目数据结构不正确。missing uid');
        }
        if (!_.has(data, 'info')) {
            return console.log('上传项目数据结构不正确。missing info');
        }
        const filePath = data.filePath;
        const utoken = data.utoken;
        const uid = data.uid;
        const info = data.info;
        const { id, projectId, syncStatus } = info;

        let _projects = [], _localList = [], payloadRst = {};

        // 判断当前用户是正常
        if (this.getStoreUid().toString() !== uid.toString()) {
            return;
        }
        try {
            //拿令牌
            const config = await Api.OssService.uploadToken({
                '_HEADER_': { utoken, 'pid': 1 }
            });
            if (config) {
                // 置为上传中
                this.isUploading = true;    // 上传中标识置 "开启"

                const { project } = this.store.getState();
                const { projects } = project;
                _projects = projects.map((p) => p.id === id ? { ...p, syncStatus: CONSTANT.PROJECT_STATUS.UPLOADING } : p);
                Emitter.emit('UpdateUploadStatus', {
                    projects: _projects
                });
                // 构造File()
                const file = await this.getBufferToFile(filePath);
                // 上传前，先拿store中上一次获得的projectId
                const projectFresh = this.findProjectByStore(id);
                info.projectId = _.has(projectFresh, 'projectId') ? projectFresh.projectId : '';
                // 上传
                Api.OssService.uploadFile(config, file, info).then(async (res) => {
                    if (res.data.code === 0) {
                        console.log('上传成功！！');
                        // 上传成功
                        const _projectId = projectId ? projectId : res.data.data.projectId;
                        const commitId = config.commitId;
                        const { project } = this.store.getState();
                        const { projects } = project;
                        _localList = await ProjectLocal.get();
                        _projects = projects.map((p) => p.id === id ? {
                            ...p, syncStatus: CONSTANT.PROJECT_STATUS.NORMAL,
                            projectId: p.projectId ? p.projectId : res.data.data.projectId,
                            commitId: commitId
                        } : p);
                        _localList[uid] = _projects;
                        ProjectLocal.set(_localList);
                        payloadRst = {
                            projects: _projects,
                            projectId: _projectId,
                            commitId: commitId,
                        };
                    } else {
                        // 上传失败
                        const { project } = this.store.getState();
                        const { projects } = project;
                        _localList = await ProjectLocal.get();
                        _projects = projects.map((p) => p.id === id ? { ...p, syncStatus } : p);
                        _localList[uid] = _projects;
                        ProjectLocal.set(_localList);
                        payloadRst = {
                            projects: _projects
                        };
                    }
                    Emitter.emit('UpdateUploadStatus', payloadRst);
                    this.isUploading = false;   // 上传中标识置 "关闭"
                }).catch((err) => {
                    this.isUploading = false;
                    console.log('ali response error', err);
                });
            }
        } catch (err) {
            this.isUploading = false;   // 上传中标识置 "关闭"
            console.log('upload project error: ', err);
        }
    }
}

const Upd = (window.MbApi && window.MbApi.MQueue) ? Uploader.getInstance() : null;

Emitter.on('MQueue.Upload.run', (length) => {
    Upd.run(length);    // 消息队列，1s触发一次通知应该pop()数据上传了
});

export default Upd;